import { render, staticRenderFns } from "./IncidentsIndex.vue?vue&type=template&id=2d4df2f6&"
import script from "./IncidentsIndex.vue?vue&type=script&lang=js&"
export * from "./IncidentsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports